class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
    
    // スクロールイベントリスナーを追加
    this.scrollHandler = this.onScroll.bind(this);
  }

  // 検索モーダルかどうかを判定
  isSearchModal() {
    return this.querySelector('.search-modal') !== null;
  }

  // スクロール位置に基づいてクラスを更新
  updateSearchModalPosition() {
    const searchModal = this.querySelector('.search-modal');
    if (!searchModal) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop === 0) {
      searchModal.classList.add('search-modal--at-top');
    } else {
      searchModal.classList.remove('search-modal--at-top');
    }
  }

  onScroll() {
    // 検索モーダルが開いている時のみ処理
    if (this.isOpen() && this.isSearchModal()) {
      this.updateSearchModalPosition();
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // 検索モーダルの場合、スクロール位置をチェック
    if (this.isSearchModal()) {
      this.updateSearchModalPosition();
      // スクロールイベントリスナーを追加
      window.addEventListener('scroll', this.scrollHandler);
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    // 検索モーダルの場合はフォーカスを戻さない
    const shouldFocusToggle = focusToggle && !this.isSearchModal();
    
    removeTrapFocus(shouldFocusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    // 検索モーダルの場合、クラスを削除
    if (this.isSearchModal()) {
      const searchModal = this.querySelector('.search-modal');
      searchModal.classList.remove('search-modal--at-top');
      // スクロールイベントリスナーを削除
      window.removeEventListener('scroll', this.scrollHandler);
    }
  }
}

customElements.define('details-modal', DetailsModal);
